import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";

const adminToken = secureStorage.getItem("adminToken");
export const getCustomers = (setCustomerData, Page, Limit, setPageData) => {
  axiosInstance
    .get(`/users/get-customers?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setCustomerData(res.data.data);
      setPageData(res.data.pagination.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const getAdmins = (setAdminData, Page, Limit, setPageData) => {
  axiosInstance
    .get(`/users/get-admins?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      const admins = res?.data?.data || []; // fallback empty array
      const totalPages = res?.data?.pagination?.totalPages || 1; // fallback 1

      setAdminData(admins);
      setPageData(totalPages);
    })
    .catch((err) => {
      console.error(err); // log actual error
      toast.error("Data is not found");
    });
};
export const registerAdmin = (
  FormData,
  setFormData,
  setAdminData,
  Page,
  Limit,
  setPageData,
  setOpen
) => {
  axiosInstance
    .post("/admin/auth/register", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
      },
    })
    .then((res) => {
      if (res.status === 201) {
        toast.success(res.data.message);
        setFormData({
          fullName: "",
          email: "",
          phoneNumber: "",
          password: "",
          isAdmin: 1,
          status: 1,
          createdAt: new Date().toISOString(),
        });
        getAdmins(setAdminData, Page, Limit, setPageData);
        setOpen(false);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
    });
};
export const updateAdmin = (
  FormData,
  setFormData,
  setAdminData,
  Page,
  Limit,
  setPageData,
  setOpen
) => {
  axiosInstance
    .put("/admin/auth/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
      },
    })
    .then((res) => {
      if (res.data.message === "User updated successfully") {
        toast.success(res.data.message);
        setFormData({
          id: "",
          fullName: "",
          email: "",
          phoneNumber: "",
          password: "",
          isAdmin: 1,
          status: 1,
          createdAt: new Date().toISOString(),
        });
        getAdmins(setAdminData, Page, Limit, setPageData);
        setOpen(false);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error(err.response.data.message);
    });
};
export const deleteAdmin = (id, setAdminData, Page, Limit, setPageData) => {
  axiosInstance
    .delete(`/admin/auth/delete-admin/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
      },
    })
    .then((res) => {
      const message = res?.data?.message;

      if (message === "Admin deleted successfully") {
        toast.success(message);

        getAdmins(setAdminData, Page, Limit, setPageData);
      } else {
        toast.error(message || "Something went wrong");
      }
    })
    .catch((err) => {
      const msg = err?.response?.data?.message || "Something went wrong";
      toast.error(msg);
    });
};
